<div class="card card-login">
  <div class="card-content">

      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h4>Forgotten your username?</h4>
          </div>
        </div>
      </div>

    <ng-container *ngIf = "!hideForm && !questionsLoaded">
      <p *ngIf="secQuestionsSelected && !recoveryEmailSelected">If you have answers of security questions stored in Able+ then enter email to get your personal security questions.</p>
      <p *ngIf="recoveryEmailSelected && !secQuestionsSelected">If you have a recovery email address stored in Able+ then enter it below to be sent your username and details to allow you to reset your password.</p><br>

      <div class="radio radio-inline">
        <label>
          <input type="radio" name="optionsRadios" [checked] = "secQuestionsSelected" (click)="onSelectSecQuestions()">
          Security Questions
        </label>
      </div><br>
      <div class="radio radio-inline">
        <label>
          <input type="radio" name="optionsRadios" (click)="onSelectRecEmail()">
          Recovery Email
        </label>
      </div><br>

      <form [formGroup] = "recoveryEmailForm" *ngIf = "this.recoveryEmailSelected && !this.secQuestionsSelected && !hideForm">
        <div class="form-group label-floating is-empty">
          <label class="control-label">Recovery email address</label>
          <input type="email" class="form-control" formControlName = 'recoveryEmail'>
          <div class="help-block" *ngIf = "recoveryEmailForm.get('recoveryEmail').errors && (recoveryEmailForm.get('recoveryEmail').dirty || recoveryEmailForm.get('recoveryEmail').touched)">
            <span class="text-danger" [hidden] = "!recoveryEmailForm.get('recoveryEmail').errors.emailFormat">The email format is invalid</span>
          </div>
        </div>

        <button
          [disabled] = "!recoveryEmailForm.valid"
          (click) ="recoverPassword()"
          class="btn btn-block btn-primary"
          [ngStyle]="{'background-color': this.sharedService?.ButtonColor?.value, 'color':  this.sharedService?.TextButtonColor?.value}"
        >
          Reset password
        </button>
      </form>

      <form [formGroup] = "emailSecQuesForm" *ngIf = "!this.recoveryEmailSelected && this.secQuestionsSelected && !hideForm">
        <div class="form-group label-floating is-empty">
          <label class="control-label">Email address</label>
          <input type="email" class="form-control" formControlName = 'email'>
          <div class="help-block" *ngIf = "emailSecQuesForm.get('email').errors && (emailSecQuesForm.get('email').dirty || emailSecQuesForm.get('email').touched)">
            <span class="text-danger" [hidden] = "!emailSecQuesForm.get('email').errors.emailFormat">The email format is invalid</span>
          </div>
        </div>

        <button
          [disabled] = "!this.emailSecQuesForm.valid"
          class="btn btn-block btn-primary"
          (click) = "loadSecurityQuestionsFromIDAM()"
          [ngStyle]="{'background-color': this.sharedService?.ButtonColor?.value, 'color':  this.sharedService?.TextButtonColor?.value}"
        >
          Get Security Questions
        </button>
      </form>
    </ng-container>

    <ng-container *ngIf = "this.questionsLoaded && !this.verifiedSecQuestions">
      <p>Please answer the security questions.</p>
      <br>

      <div class="input-group" [formGroup]="securityQuestionForm" novalidate>
        <div class="row form-horizontal" formArrayName="securityQuestion">
          <div *ngFor="let security of this.secQuesToDisplay['controls']; let i=index">
            <div [formGroupName]="i">
              <div class="form-group">
                <div class="col-md-10">
                  <span class="number-circle pull-left margin-right-base"> {{i+1}}</span> {{security['controls'].question.value}}
                  <input class="form-control" type="text" formControlName="answer"><br>
                </div>
                <br><br>
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn btn-block btn-primary"
          [disabled]="!securityQuestionForm.valid"
          (click) = "verifyAnswersForSecurityQuestions()"
          [ngStyle]="{'background-color': this.sharedService?.ButtonColor?.value, 'color':  this.sharedService?.TextButtonColor?.value}"
        >
          Verify Answers
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf = "this.verifiedSecQuestions == true">
      <p>Answers of yours security questions were correct. Your username is <strong>{{this.usernameReturned.username}}</strong>.
        You can login with recovered username <a routerLink="/login" routerLinkActive="active">now</a> .</p>
    </ng-container>

    <div *ngIf= "hideForm">
      <p>A confirmation link has been sent to your email address. Please follow the instructions in the email to reset your password.</p>
      <p>If you do not receive an email then please contact your organisation's Able+ administrator.</p>
    </div>

  </div>

  <div class="footer text-center">
    <p class="small">
      <a routerLink="/login" routerLinkActive="active">
        Sign in with a different account
      </a>
    </p>
  </div>

</div>
